import { axiosPost } from '../../axios/axios.js'
import { prepareFilesDataToUpload, getUploadResult } from '../helpers.js'
import { loadPreloadedFiles } from './FileUtils'

export const journalRecordFilesGroups = {
  data: function () {
    return {
      documentsProperty: 'documents',
      documentUploadURL: null, // @Abstract
      documentRemoveURL: null, // @Abstract

      filesGroups: []
      // filesGroupsMap: {}, // не реактивное
    }
  },
  computed: {
    validFilesGroups: function () {
      return this.filesGroups.find(filesGroup => this.checkFilesGroupValid(filesGroup, false) === false) == null
    }
  },
  methods: {
    // @Abstract
    getRecordId: function () {
      return null
    },
    // @Abstract
    getFilesPreloadFormId: function () {
      return null
    },
    // @Default
    prepareFilesGroups: function () {
      this.clearFilesGroups()
      // ... Заполнение this.filesGroups
      this.loadPreloadedFiles()
    },

    getAllFiles: function () {
      const allFiles = []
      this.filesGroups.forEach(filesGroup => {
        allFiles.push(...filesGroup.files)
      })
      return allFiles
    },
    getDocumentsIds: function (fileFilterFn) {
      let files = this.getAllFiles()
      if (fileFilterFn) {
        files = files.filter(fileFilterFn)
      }
      return files.map(file => file.id)
    },
    // validateFilesGroups: function (strict) {
    //   return this.getFilesGroupsValidationMessages(strict).length === 0
    // },
    getFilesGroupsValidationMessages: function (strict) {
      const invalidFilesGroupsMessages = []
      this.filesGroups.forEach(filesGroup => {
        if (!this.validateFilesGroup(filesGroup, strict)) {
          invalidFilesGroupsMessages.push(filesGroup.props.validationMessage)
        }
      })
      return invalidFilesGroupsMessages
    },
    validateFilesGroup: function (filesGroup, strict) {
      const valid = this.checkFilesGroupValid(filesGroup, strict)
      if (filesGroup.props.collapseId) {
        const filesCollapseEl = document.getElementById(filesGroup.props.collapseId)
        if (filesCollapseEl) {
          filesCollapseEl.setAttribute('style', valid ? 'border: none;' : 'border: solid 2px rgb(193, 0, 21);')
        }
      }
      return valid
    },
    checkFilesGroupValid: function (filesGroup, strict) {
      let valid = true
      if (filesGroup.props.required) {
        let hasFiles = !!filesGroup.files.length
        if (!hasFiles && !strict) {
          hasFiles = !!filesGroup.filesToUpload.length
        }
        valid = hasFiles
      }
      if (valid) {
        valid = !(filesGroup.filesToUpload.find(file => !!file.uploadError))
      }
      return valid
    },
    clearFilesGroups: function () {
      this.filesGroups.forEach(filesGroup => {
        filesGroup.clear()
      })
    },
    loadPreloadedFiles: function () {
      return loadPreloadedFiles(this.getFilesPreloadFormId())
        .then(documents => {
          documents.forEach(document => {
            this.pushFile(document)
          })
        })
    },
    pushFile: function (document, props) {
      let filesGroup = this.filesGroupsMap[document.category]
      if (!filesGroup) {
        filesGroup = this.filesGroupsMap[document.type]
      }
      if (filesGroup) {
        return filesGroup.pushFile(document, {
          props: props // TODO FileDocument - name
        })
      }
      return null
    },
    onFileAddToUpload: function (fileWrapper) {
      const duplicates = this.getFileDuplicates(fileWrapper)
      if (duplicates.length) {
        fileWrapper.uploadError = {
          status: 'error',
          code: 'duplicate',
          message: 'Файл уже был прикреплён'
        }
        duplicates.forEach(fileWrapperDuplicate => {
          fileWrapperDuplicate.uploadError = fileWrapper.uploadError
        })

        this.$q.notify({
          type: 'negative',
          message: fileWrapper.uploadError.message,
          progress: true,
          timeout: 8000
        })
      }
    },
    onFileRemoveFromUpload: function (fileWrapper) {
      this.updateDuplicatesOnFileRemove(fileWrapper)
    },
    updateDuplicatesOnFileRemove: function (fileWrapper) {
      const duplicates = this.getFileDuplicates(fileWrapper)
      if (duplicates.length === 1) {
        duplicates[0].uploadError = null
      }
    },
    getFileDuplicates: function (fileWrapper) {
      const duplicates = []
      this.filesGroups.forEach(filesGroup => {
        duplicates.push(...filesGroup.filesToUpload.filter(fileWrapperAnother => fileWrapper.checkDuplicate(fileWrapperAnother)))
        duplicates.push(...filesGroup.files.filter(fileWrapperAnother => fileWrapper.checkDuplicate(fileWrapperAnother)))
      })
      return duplicates
    },
    onFileUploadSuccess: function ({ document, filesGroup }) {
    },
    uploadFiles: async function () {
      const url = this.documentUploadURL
      const recordId = this.getRecordId() || -1

      const filesData = []
      this.filesGroups.forEach(filesGroup => {
        const uploadConfig = {
          objectId: recordId,
          preloadFormId: this.getFilesPreloadFormId(),
          files: filesGroup.filesToUpload,
          categoryKey: filesGroup.key, // TODO  filesGroup.categoryKey
          url: url,
          documentType: filesGroup.documentType,
          property: this.documentsProperty
        }
        filesData.push(...prepareFilesDataToUpload(uploadConfig))
      })

      return getUploadResult(filesData, true, this, true)
    },
    onFileRemove: function ({ file: fileWrapper, filesGroup }) {
      const url = this.documentRemoveURL
      const params = new URLSearchParams()
      params.append('recordId', this.getRecordId() || -1)
      params.append('id', fileWrapper.id)
      params.append('property', this.documentsProperty)

      axiosPost({
        url: url + '?' + params.toString(),
        onSuccess: () => {
          filesGroup.deleteFile(fileWrapper)
          this.updateDuplicatesOnFileRemove(fileWrapper)
        },
        onFailure: 'Ошибка удаления файла'
      })
    }
  }
}
